<template>
  <qx-card title="列表">
    <LogRightDialog ref="logRightDialog" busiCode="100004" auditCode="100009" />

    <UploadDriverCardDialog
      ref="uploadDriverCardDialog"
      bizCodes="imp1000113"
      @sub="getData"
      warning="温馨提示：请将挂车的行驶证正本的照片打成一个压缩包，压缩包格式支持：RAR、ZIP，图片格式支持：BMP、JPG、GIF、PNG，如挂车档案已存在，则会更新。"
    />

    <section slot="titleRight">
      <qx-permpisions permpisions>
        <el-dropdown>
          <el-button type="primary" plain>
            <i class="iconfont">&#xe6ac;</i>批量操作
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <qx-permpisions>
              <el-dropdown-item @click.native="showUploadFileDialog">上传文件新增挂车</el-dropdown-item>
            </qx-permpisions>
            <qx-permpisions>
              <el-dropdown-item @click.native="showBatchUploadLicenseDialog">上传图片新增挂车</el-dropdown-item>
            </qx-permpisions>
          </el-dropdown-menu>
        </el-dropdown>
      </qx-permpisions>
      <qx-permpisions permpisions="1400306">
        <ImportBtn
          ref="importBtn"
          title="挂车档案导入"
          bizCodes="imp1000122"
          fileUrl="/file/挂车档案导入模板.xlsx"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400307">
        <ExportBtn
          :len="tableData.data.length"
          queryUrl="trailerBO.ajax?cmd=doExportTrailerInfo"
          :params="fullSearchData"
          bizName="挂车档案信息导出"
          bizCode="exp100099"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
        />
      </qx-permpisions>
      <qx-permpisions permpisions="1400301">
        <el-button type="primary" plain @click="() => toSaveOrUpdate(null, 1)">
          <i class="iconfont">&#xe6ab;</i>新增
        </el-button>
      </qx-permpisions>
    </section>

    <section class="tablePage">
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'trailerNumber'"
          >
            <section slot-scope="scope">
              <section v-if="scope.column.property === 'trailerNumber'">
                <span
                  class="primary cur"
                  @click="trailerDetail(scope.row, '')"
                >{{ scope.row[scope.column.property] }}</span>
              </section>
              <section v-else-if="scope.column.property === 'certificateWarning'">
                <template v-if="!(scope.row.vehicleEarlyWarningDay == null)">
                  <span
                    v-if="
                      scope.row.vehicleEarlyWarningDay != null &&
                      scope.row.vehicleEarlyWarningDay > 0
                    "
                  >{{ scope.row.vehicleEarlyWarningDay }}天后行驶证过期</span>
                  <span
                    v-if="
                      scope.row.vehicleEarlyWarningDay != null &&
                      scope.row.vehicleEarlyWarningDay <= 0
                    "
                  >行驶证已过期</span>
                </template>
              </section>
              <section v-else-if="scope.column.property === 'position'">
                <span class="primary cur">
                  {{
                  scope.row.sourceRegionString
                  ? scope.row.sourceRegionString.replace('市', '')
                  : '-'
                  }}/{{ scope.row.sourceCountyString }}-{{
                  scope.row.stateString
                  }}
                </span>
                <el-popover placement="top" width="120" trigger="hover">
                  <div style="text-align: center">
                    <span
                      class="primary cur"
                      style="text-align: center"
                      @click="updateLocation(scope.row.trailerId)"
                    >更新位置</span>
                  </div>
                  <i class="el-icon-question warning" slot="reference"></i>
                </el-popover>
              </section>

              <section v-else-if="scope.column.property === 'usageCount'">
                <span
                  class="primary cur"
                  @click="queryUsedLineList(scope.row.trailerNumber)"
                >{{ scope.row.usageCount }}</span>
              </section>
              <section v-else>
                <span>{{ scope.row[scope.column.property] }}</span>
              </section>
            </section>
          </el-table-column>
          <el-table-column prop="control" label="操作" fixed="right" width="140">
            <template slot-scope="scope">
              <TableBtn
                :tableData="scope.row"
                :btnList="[
                  {
                    showCondition: scope.row.audit === 1,
                    name: '审核',
                    event: () => toSaveOrUpdate(scope.row, 3),
                  },
                  {
                    permpisions: '1400302',
                    showCondition: true,
                    name: '修改',
                    event: () => toSaveOrUpdate(scope.row, 2),
                  },
                  {
                    permpisions: '1400311',
                    showCondition: scope.row.useState === 1,
                    name: '闲置',
                    event: () => doUpdUse(scope.row.trailerId, 0),
                  },
                  {
                    permpisions: '1400310',
                    showCondition: scope.row.useState !== 1,
                    name: '在用',
                    event: () => doUpdUse(scope.row.trailerId, 1),
                  },
                  {
                    permpisions: '1400308',
                    showCondition: true,
                    name: '删除',
                    event: () => doRemove(scope.row),
                  },
                  {
                    showCondition: true,
                    name: '日志',
                    event: () => showLog(scope.row.trailerId),
                  },
                ]"
              />
            </template>
          </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import LogRightDialog from 'components/logRightDialog';
import ImportBtn from 'components/importBtn';
import ExportBtn from 'components/exportBtn';
import UploadDriverCardDialog from 'components/uploadDriverCardDialog';
import TableBtn from 'components/tableBtn/tableBtn';
import {
  queryTrailerManagement,
  doUpdUseState,
  deleteTrailer,
  updateLocation,
} from 'api/car';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    LogRightDialog,
    ImportBtn,
    ExportBtn,
    UploadDriverCardDialog,
    TableBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'trailerNumber',
            label: '车牌号码',
            slot: true,
          },
          {
            prop: 'vehicleClassName',
            label: '挂车种类',
            slot: true,
          },
          {
            prop: 'trailerType',
            label: '车辆类型',
            slot: true,
          },
          {
            prop: 'certificateWarning',
            label: '证件预警',
            slot: true,
            w: 140,
          },
          {
            prop: 'vinNo',
            label: '车架号',
          },
          {
            prop: 'position',
            label: '位置状态',
            slot: true,
            w: 150,
          },
          {
            prop: 'trailerMaterialString',
            label: '挂车材质',
          },
          {
            prop: 'usageCount',
            label: '使用情况',
          },
          {
            prop: 'auditStateName',
            label: '待审核状态',
          },
          {
            prop: 'useStateName',
            label: '使用状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryTrailerManagement,
    showUploadFileDialog () {
      this.$refs.importBtn.showImportDialog();
    },
    showUploadPicDialog () {
      // TODO
    },
    showBatchUploadLicenseDialog () { // 批量上传行驶证
      this.$refs.uploadDriverCardDialog.show();
    },
    trailerDetail (item, type) {
      this.jump({
        label: `${type ? '审核' : '查看'}挂车-${item.trailerNumber}`,
        url: `/manage/car/trailer/archives/detail?id=${item.trailerId}&type=${type}`,
        full: true,
      });
    },
    toSaveOrUpdate (item, index) {
      switch (index) {
        case 1:
          // 新增，item 为 null
          this.jump({
            label: '新增挂车',
            url: '/manage/car/trailer/edit?id=',
            full: true,
          });
          break;
        case 2:
          this.jump({
            label: '修改挂车',
            url: `/manage/car/trailer/edit?id=${item.trailerId}`,
            full: true,
          });
          break;
        case 3:
          // 审核
          this.trailerDetail(item, 'approve');
          break;
        default:
          break;
      }
    },
    async doRemove (item) {
      const confirmRes = await this.$confirm(`确认删除车牌号码【${item.trailerNumber}】的挂车？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        await deleteTrailer({
          trailerId: item.trailerId,
        });
        this.getData();
      }
    },
    async doUpdUse (trailerId, useState) {
      await doUpdUseState({
        trailerId,
        useState,
      });
      this.getData();
    },
    async updateLocation (trailerId) {
      await updateLocation({ trailerId });
    },
    queryUsedLineList (trailerNumber) {
      this.jump({
        label: '挂车使用线路',
        url: `/manage/car/trailer/common/usedLine?id=${encodeURI(trailerNumber)}`,
        full: true,
      });
    },
    showLog (id) {
      this.$refs.logRightDialog.show(id);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
